
<!-- <div class="pageStyle">
  <h1>4O4</h1>
  <h2>Page Not Found</h2>
</div> -->

<div class="container">
  <div class="row">
      <div class="col-md-12">
          <div class="error-template">
              <h1>Oops!</h1>
              <h2>We are sorry, Page not found!</h2>
              <div class="error-details">
                The page you are looking for might have been removed had its name changed or is temporarily unavailable.
              </div>
              <div class="error-actions">
                  <a href="" class="btn btn-lg">Take Me Home </a>
              </div>
          </div>
      </div>
  </div>
</div>


